export const SET_CONCLUSION_MESSAGE = "SET_CONCLUSION_MESSAGE";
